var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { getUtmList, getUTMhash, getSiteStatusStyle } from "app/lib/lib";
import * as moment from 'moment-timezone';
import { InfoModalComponent } from "../modal/info_modal.component";
var RefDetailComponent = /** @class */ (function (_super) {
    __extends(RefDetailComponent, _super);
    function RefDetailComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.utmList = getUtmList();
        _this.getUTMhash = getUTMhash;
        _this.getSiteStatusStyle = getSiteStatusStyle;
        _this.moment = moment;
        return _this;
    }
    RefDetailComponent.prototype.ok = function () {
        this.close();
    };
    RefDetailComponent.prototype.ngOnInit = function () {
        var me = this;
        this.stats.forEach(function (stat) {
            var utm = getUTMhash(stat.mark);
            stat.utmData = me.utmList.reduce(function (obj, utmKey) { if (utm[utmKey]) {
                obj[utmKey] = utm[utmKey];
            } ; return obj; }, {});
        });
    };
    return RefDetailComponent;
}(InfoModalComponent));
export { RefDetailComponent };
